import BM from './b&m'
import CookBook from './cookbook'

const books = [ BM, CookBook ]

export default books